import { Position, OverlayToaster } from '@blueprintjs/core';

export const BottomRightToaster = OverlayToaster.create({
  position: Position.BOTTOM_RIGHT,
});
